import { _, React, classNames, withStyles, StyledProps, Fragment,  } from '@api'
import {Tooltip2} from '@api'
import { CentricTheme } from 'centric-ui-components'
import {CatalogStore} from '@stores'
import { List, Divider, ListItem, Typography, ListItemText, Theme, Tooltip } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  root: {},
  header: {
    color: theme.colors.caption,
    height: theme.spacing() * 6,
    alignItems: 'center',
    fontWeight: 'normal',
    letterSpacing: '0.4',
    lineHeight: '1.33',
    padding: `${(theme.spacing() * 2) + 2}px ${theme.spacing() * 2}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box'
  },
  listItem: {
    height: theme.spacing() * 6,
    '&:last-child': {
      marginBottom: theme.spacing()
    }
  },
  listItemText: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '0 24px'
  },
  primaryText: {
    fontSize: 14,
    color: theme.colors.display,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  secondaryText: {
    position: 'absolute',
    right: 0,
    color: theme.colors.caption,
    fontSize: 10,
    // minWidth:'2.5em',
    // textAlign: 'center'
  },
  footer: {
    height: 64,
    width: 299,
    position: 'absolute',
    bottom: 64,
    backgroundColor: '#FFF',
    borderTop: '1px solid #dedede'
  },
  librariesBtn: {
    width: '100%',
    height: 64
  },
  divider: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing()
  }
})

interface MyProps extends StyledProps {
  data: { libraries?: Array<{ label, name, count?: number, disabled?: any }>,
   attributes?: Array<{ label, name, definition, count?: number,booleanLabels?: any, disabled?: any }> 
   merchProductLibraries?:Array<{ label, name, count?: number, disabled?: any }>}
  onClickItem: (e, libraryName: string, attributeDefinition?: string) => void
  onClikManageLibraries?: (e) => void
  isSeaosonalSpecView?: boolean
  singularLibraryName?: string
  catalog?: CatalogStore
}

@(withStyles as any)(styles)
export class SideBarList extends React.Component<MyProps> {
  static defaultProps = {}

  render() {
    const {catalog: {strings, vlp}, className, data, classes, onClickItem, isSeaosonalSpecView, singularLibraryName} = this.props

    let listHeader = isSeaosonalSpecView ? `${singularLibraryName} ${strings.seasonalLibraries}` : strings.specLibraries
    let libraryData = data.libraries;
    if(vlp.isVLPView){
      listHeader = strings.mercOptionsLibraries;
      libraryData = data.merchProductLibraries || libraryData;
    }
    return (
      <div className={classNames(classes.root, className)}>
      <Typography className={classes.header} variant={'body1'} title={listHeader}>{listHeader}</Typography>
        <List disablePadding>
          {
            libraryData.map((library, index) => {
              if (library.name) {
                return (
                  <ListItem key={`${library.name}-${index}`} onClick={(e) => {
                    onClickItem(e, library.name)
                  }}
                  button classes={{root: classes.listItem}}
                  data-id={`spec-library-${library.name}`}
                  disabled={library.disabled}>
                    <Tooltip2 content={library.label}>
                      <ListItemText
                        classes={{
                          root: classes.listItemText,
                          primary: classes.primaryText,
                          secondary: classes.secondaryText
                        }}
                        primary={library.label}
                        secondary={library.count}
                      />
                    </Tooltip2>
                  </ListItem>
                )
              }
              return <Divider key={`lib_divider_${index}`} className={classes.divider}/>
            })
          }
        </List>
        {!vlp.isVLPView && !isSeaosonalSpecView &&
        <Fragment>
          <Divider/>
          <Typography className={classes.header} variant={'body1'}>{strings.productAttributes}</Typography>
          <List disablePadding>
            {
              _.map(data.attributes, (attribute, index) => {
                if (attribute.name) {
                  return (
                    // onClickItem(e, attribute.name) // TODO: rewire the onClick for tags once new component is implemented
                    <ListItem key={`${attribute.name}_${index}`} onClick={(e) => {
                      onClickItem(e, attribute.name, attribute.definition)
                    }} button classes={{root: classes.listItem}} 
                    data-id={`custom-attributes-${attribute.label}`}
                    disabled={attribute.disabled}>
                      <Tooltip2 content={attribute.label}>
                        <ListItemText
                          classes={{
                            root: classes.listItemText,
                            primary: classes.primaryText,
                            secondary: classes.secondaryText
                          }}
                          primary={attribute.label}
                          secondary={attribute.count}
                        />
                      </Tooltip2>
                    </ListItem>
                  )
                }
                return <Divider key={`attr_divider_${index}`} className={classes.divider}/>
              })
            }
          </List>
        </Fragment>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/SideBarList.tsx